import { useQuery } from '@tanstack/react-query';
import { WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS } from '../constants';
import { fetchWebsiteAnalyticsDevices } from '../services/websiteAnalytics.api';
import type { WebsiteAnalyticsDays } from '../types';

export function useWebsiteAnalyticsDevices(
  days: WebsiteAnalyticsDays,
  productSlug: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['website-analytics', 'devices', days, productSlug ?? 'all'],
    queryFn: () => fetchWebsiteAnalyticsDevices(days, productSlug),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
